export class ParentMessage {
    id: string;
    object: any;
}
